import { Button, Link, Toast, ToastFooter, ToastTitle, ToastTrigger } from '@fluentui/react-components';
import { Dismiss16Filled } from '@fluentui/react-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface AppNotificationProps {
    message: string;
    intent: 'info' | 'success' | 'warning' | 'error';
    primaryActionLabel?: string;
    primaryAction?: () => void;
}

// shows a toast notification in the web app (e.g. for errors, warnings, etc.)
const AppNotification: FC<AppNotificationProps> = ({ message, primaryActionLabel, primaryAction }) => {
    const { t } = useTranslation();
    return (
        <Toast>
            <ToastTitle
                action={
                    <ToastTrigger>
                        <Button icon={<Dismiss16Filled />} />
                    </ToastTrigger>
                }
            >
                {t(message)}
            </ToastTitle>
            {
                primaryActionLabel
                    ? <ToastFooter>
                        <Link onClick={primaryAction}>{primaryActionLabel}</Link>
                    </ToastFooter>
                    : null
            }
        </Toast>
    );
};

export default AppNotification;
